import { useState, useEffect, useCallback } from "react";
import RepositoryFactory from "../../../../../../../repositories/RepositoryFactory";

export const useCatalogs = (lang) => {
  const PurchaseOrderClient = RepositoryFactory.get("PurchaseOrder");
  const [incotermCatalog, setIncotermCatalog] = useState([]);
  const [uomCatalog, setUOMCatalog] = useState([]);
  const [transportModeCatalog, setTransportModeCatalog] = useState([]);
  const [uomCatalogO, setUOMCatalogO] = useState([]);
  const [uomCatalogV, setUOMCatalogV] = useState([]);
  const [uomCatalogT, setUOMCatalogT] = useState([]);
  const [uomCatalogW, setUOMCatalogW] = useState([]);
  const [uomCatalogQ, setUOMCatalogQ] = useState([]);
  const [uomCatalogD, setUOMCatalogD] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const getCatalogs = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await PurchaseOrderClient.getCatalogs(lang);
      setIncotermCatalog(response.data.incoterms);
      setUOMCatalog(response.data.uom);
      setTransportModeCatalog(response.data.transportModes);
      setUOMCatalogO(response.data.uomO || []);
      setUOMCatalogV(response.data.uomV || []);
      setUOMCatalogT(response.data.uomT || []);
      setUOMCatalogW(response.data.uomW || []);
      setUOMCatalogQ(response.data.uomQ || []);
      setUOMCatalogD(response.data.uomD || []);
      setLoading(false);
    } catch (error) {
      console.log("error", error);
      setError(error);
      setLoading(false);
    }
  }, [PurchaseOrderClient, lang]);

  useEffect(() => {
    getCatalogs();
  }, [getCatalogs, lang]);

  return {
    incotermCatalog,
    uomCatalog,
    uomCatalogD,
    uomCatalogO,
    uomCatalogQ,
    uomCatalogT,
    uomCatalogV,
    uomCatalogW,
    transportModeCatalog,
    loading,
    error,
  };
};
